import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import Titlebar from './../titlebar/titlebar';
import Navbar from './../navbar/navbar';
import { showBlocker, hideBlocker } from './../../actions/blocker';
import CheckApi from '../master-data/checkapi';

const PrivateRoute = ({ auth, user, showBlocker, hideBlocker, component: C, location, ...rest }, props) => {
    if (!auth || !user) {
        return <Redirect to={{ pathname: '/login', state: { from: location } }} />;
    }
    else {
        return <><Route
            render={props =>
                <>
                    <div className='flex-shrink-0' style={{ zIndex: 9 }}>
                        <div style={{ boxShadow: '0 8px 12px rgba(255,255,255,.3)' }}>
                            <Titlebar username={user && (user.name || user.username)} />
                        </div>
                        <Navbar tabs={(user && user.perms && user.perms.tabs) || []}  />
                    </div>
                    <div className='flex-grow-1 d-flex flex-column overflow-auto'>
                        <C {...props} />
                    </div>
                    
                </>
            }
            {...rest}
        />
        
        </>
    }
};

const mapStateToProps = state => ({ ...state.auth });

const mapActionsToProps = { showBlocker, hideBlocker };

export default connect(mapStateToProps, mapActionsToProps)(PrivateRoute);
